<template>
<div class="rounded-4xl"></div>
</template>

<script>
import OT from '@opentok/client';
export default {
    name: 'PatientVideo',
    data: () => ({
        publisher: undefined
    }),
    props: {
        session: {
            type: OT.Session,
            required: false
        },
        opts: {
            type: Object,
            required: false
        },
        hasAudio: {
            type: Boolean,
            required: false
        },
        hasVideo: {
            type: Boolean,
            required: false
        },
        switchVideoInput: {
            type: Boolean,
            required: false
        }
    },
    watch: {
        hasAudio(status) {
            this.changeStatusAudio(status);
        },
        hasVideo(status) {
            this.changeStatusVideo(status);
        },
        switchVideoInput() {
            this.changeVideo();
        },
    },
    mounted: function () {
        this.initPatientSession();
    },
    methods: {
        init() {
            const subscriber = this.session.subscribe(
                this.stream,
                this.$el,
                this.opts,
                err => {
                    if (err) {
                        this.$emit('error', err);
                    } else {
                        this.$emit('subscriberConnected', subscriber);
                    }
                }
            );
            this.$emit('subscriberCreated', subscriber);
        },
        initPatientSession() {
            const publisher = OT.initPublisher(this.$el, this.opts, err => {
                if (err) {
                    this.$emit('error', err);
                } else {
                    this.$emit('publisherCompleted');
                }
            });
            this.$emit('publisherCreated', publisher);
            const publish = () => {
                this.session.publish(publisher, err => {
                    if (err) {
                        this.$emit('error', err);
                    } else {
                        this.$emit('publisherConnected', publisher);
                    }
                });
            };
            if (this.session && this.session.isConnected()) {
                publish();
            }
            if (this.session) {
                this.session.on('sessionConnected', publish);
            }
            this.publisher = publisher;
        },
        changeStatusAudio(status) {
            this.publisher.publishAudio(status);
        },
        changeStatusVideo(status) {
            this.publisher.publishVideo(status);
        },
        changeVideo() {
            this.publisher.cycleVideo();
        }
    }
};
</script>

<style>
div {}
</style>

